import './App.css';
import TicTacToe from './components/TicTacToe/TicTacToe';

function App() {
  return (
    <div>
      <TicTacToe />
    </div>
  );
}

export default App;
